function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    html {\n        padding: 1em;\n    }\n\n    @media (min-width: 34em) {\n        html {\n            padding: 1em calc(50% - 16em);\n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { css } from '@emotion/react';
export var page = css(_templateObject());